import { Details } from '@core/ui';
import { Modal, Row, Spin } from 'antd';
import { useCallback, useMemo } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { useCountryById } from '../hooks';

export const CountryDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const { data, isFetching } = useCountryById(id);

  const openEdit = useCallback(() => {
    history.push(generatePath('/@next/countries/:id/update', { id }));
  }, [history, id]);

  const onCancel = useCallback(() => {
    history.goBack();
  }, [history]);

  const customFields = useMemo<[string, string][]>(() => {
    if (!data) return [];
    return Object.entries(JSON.parse(data.custom_fields));
  }, [data]);
  return (
    <Modal width={900} visible okText='Düzəliş et' onOk={openEdit} onCancel={onCancel}>
      <Spin spinning={isFetching}>
        <br />
        <Row gutter={[24, 24]}>
          <Details.Col xs={24} lg={12}>
            <Details.Card title='Ümumi məlumat'>
              <Details.Descriptions bordered={true} column={1} size='small'>
                <Details.Descriptions.Item label='Ölkə adı'>{data?.country_name}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Açıqlama'>{data?.descr}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Qısaltma'>{data?.abbr}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Ölçü'>{data?.unit}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Valyuta'>{data?.currency}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Valyuta tipi'>{data?.currency_type}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Poçt kodu'>{data?.postal_code}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Kisə filial bağlılığı'>{data?.box ? 'Var' : 'Yoxdur'}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Sifariş et xidməti'>{data?.is_order ? 'Var' : 'Yoxdur'}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Bəyan etmək'>{data?.is_declaration ? 'Var' : 'Yoxdur'}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='SMS təsdiq nömrəsi'>{data?.sms_confirmation ? 'Var' : 'Yoxdur'}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Yaradılıb'>{data?.created_at}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Ölkə kodu'>{data?.country_code}</Details.Descriptions.Item>
              </Details.Descriptions>
            </Details.Card>
          </Details.Col>
          <Details.Col xs={24} lg={12}>
            <Details.Card>
              <Details.Descriptions>
                <Details.Descriptions.Item label='Daşıyıcı şirkəti'>{data?.carrier_company_name}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Adres'>{data?.address}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Adres başlığı'>{data?.address_heading}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Min. həcm ölçüsü '>{data?.min_size}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Status'>{+data?.state_id! === 63 ? 'Aktiv' : 'Deaktiv'}</Details.Descriptions.Item>
                <Details.Descriptions.Item label='Daşıyıcı şirkəti adresi'>{data?.carrier_company_address}</Details.Descriptions.Item>
                {customFields.map((elem) => (
                  <Details.Descriptions.Item key={elem[0]} label={elem[0]}>
                    {elem[1]}
                  </Details.Descriptions.Item>
                ))}
              </Details.Descriptions>
            </Details.Card>
          </Details.Col>
        </Row>
      </Spin>
    </Modal>
  );
};
